import {
	Box,
	TextField,
	FormControl,
	InputAdornment,
	InputLabel,
	Input,
	IconButton,
	Button,
	Typography,
	Select,
	MenuItem,
	FormHelperText,
	Alert,
	Checkbox,
} from "@mui/material";
import {
	AccountCircleOutlined,
	Visibility,
	VisibilityOff,
	LockOutlined,
	Group,
} from "@mui/icons-material";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { set, uniqBy } from "lodash";
import { Tabs } from "../../components/tabs";
import { Grid } from "../../components/table";
import { CONFIG } from "../../../config";
import axios from "axios";
import { ToolBar } from "../../components/toolbar";
import { Modal } from "../../components/modal";
import { FormA } from "../../components/form";
import moment from "moment";
import { getFormState } from "../../../helpers/form";
import dayjs from "dayjs";
import { SelectA } from "../../components/form";
import { HRDashboard } from './hr';
import { LeadDashboard } from "./teamLead";
import { TeleDashboard } from "./tele";
import {LeadDashboard2} from "./teamLead2";

const { uniq } = require("lodash");

const API_HOST = CONFIG.modules["accounts"].host;

const itemsAdmin = {
	'HR Dashboard': {
		name: "HR Dashboard",
		view: () => <></>,
		view: () => <HRDashboard />,
	},
	// 'Telecaller': {
	// 	name: "Telecaller",
	// 	view: () => <TeleDashboard />
	// },
	'Team Lead Dashboard': {
		name: "Team Lead Dashboard",
		view: () => <LeadDashboard2 />,
	},


};

const itemsTeleCaller = {

	'Dashboard': {
		name: "Dashboard",
		view: () => <TeleDashboard />
	},
};

const itemsLead = {

	'Dashboard': {
		name: "Dashboard",
		view: () => <LeadDashboard2 />
	},
};

const itemsHR = {

	'Dashboard': {
		name: "Dashboard",
		view: () => <HRDashboard />
	},
};

export const HomeDashboard = (props) => {
	const {
		roles,
		user,
		users,
		Designations,
		Departments,
		Languages,
		Districts,
		TaskTypes,
		Campaigns,
		map
	} = useSelector((state) => state.user || {});
	const [items, setItems] = useState([])
	const [active, setActive] = useState("Dashboard");
	console.log(user, map.Roles)

	useEffect(()=> {
		if(user?.roles?.includes(process.env.REACT_APP_ADMIN)) {
			setItems(itemsAdmin)
			setActive('HR Dashboard')
		} else if(user?.roles?.includes(process.env.REACT_APP_HR)) {
			setItems(itemsHR)
			setActive('Dashboard')
		}else if(user?.roles?.includes(process.env.REACT_APP_LEAD)) {
			setItems(itemsLead)
			setActive('Dashboard')
		}
		else if(user?.roles?.includes(process.env.REACT_APP_TELECALLER)) {
			setItems(itemsTeleCaller)
			setActive('Dashboard')
		}
	},[])

	return (
		<>
			<Tabs
				items={items}
				active={active}
				onChange={(key) => {
					setActive(key);
				}}
			/>

			
					{items[active] && items[active].view && items[active].view()}
				

			
		</>
	);
};
